/**
 * == Controller: TablesController
 *
 * Provides expand/collapse behaviour for log tables in the platform UI.
 * Keeps desktop and mobile row representations in sync while updating
 * accessibility attributes.
 *
 * === Responsibilities:
 * - Toggle active state styling for the clicked row.
 * - Manage twin row layouts (desktop + mobile details).
 * - Update ARIA attributes to reflect the expanded state.
 */
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["pane"];

    // Click handler wired via data-action="click->tables#toggle"
    toggle(event) {
        event.preventDefault();

        const toggleCell = event.currentTarget;                         // the <td> with the click
        const row = toggleCell.closest("tr.logs_table_row");            // desktop row
        if (!row) return;

        // The mobile details row is the next <tr> within the same tbody
        const tbody = row.closest("tbody.logs_row");
        const mob = tbody?.querySelector("tr.logs_table_mob_details");

        // Toggle whole-row active state (rotates icon, removes dashed border on mobile, etc.)
        const willExpand = !row.classList.contains("active");
        row.classList.toggle("active", willExpand);

        // Toggle all panes (question + answer)
        row.querySelectorAll(".pane").forEach(pane => {
            pane.classList.toggle("active", willExpand);
        });

        // Mobile details block
        if (mob) mob.classList.toggle("active", willExpand);

        // a11y state
        toggleCell.setAttribute("aria-expanded", willExpand ? "true" : "false");
    }
}
